import { takeEvery, takeLatest } from 'redux-saga/effects';
import { REGION_REGISTRY_MODULE } from '../../../configs/moduleNames';
import {
  CARRIER_HELPER,
  LOAD_CARRIER_BY_ID,
  LOAD_CARRIER_LIST,
  LOAD_SZLT_BY_ID,
  LOAD_SZLT_LIST,
  LOAD_VEHICLES_BY_ID,
  LOAD_VEHICLES_LIST,
  SZLT_HELPER,
  VEHICLES_HELPER,
  SEND_VEHICLES_FGIS_TAXI,
  CARRIER_FIELDS_VALIDATION,
  VEHICLE_FIELDS_VALIDATION,
  SZLT_FIELDS_VALIDATION,
  LOAD_RELATION_CARRIER_SZLT_LIST,
  LOAD_RELATION_CARRIER_VEHICLE_LIST,
  LOAD_RELATION_VEHICLE_SZLT_LIST,
  LOAD_CARRIER_LIST_MODAL, EXTRACT_VEHICLES, EXTRACT_CARRIER, EXTRACT_SZLT, LOAD_STATUS_IMPORT,
} from '../actions';

import loadSZLTList from './loadSZLTList';
import loadSZLTById from './loadSZLTById';
import loadCarrierList from './loadCarrierList';
import loadCarrierById from './loadCarrierById';
import loadVehiclesList from './loadVehiclesList';
import loadVehiclesById from './loadVehiclesById';
import vehiclesHelper from './vehiclesHelper';
import szltHelper from './szltHelper';
import carrierHelper from './carrierHelper';
import sendVehiclesFgisTaxi from './sendVehiclesFgisTaxi';
import loadCarrierFieldsValidation from './loadCarrierFieldsValidation';
import loadSZLTFieldsValidation from './loadSZLTFieldsValidation';
import loadVehicleFieldsValidation from './loadVehicleFieldsValidation';
import loadRelationCarrierSzltList from './loadRelationCarrierSzltList';
import loadRelationCarrierVehicleList from './loadRelationCarrierVehicleList';
import loadRelationVehicleSzltList from './loadRelationVehicleSzltList';
import loadCarrierListModal from './loadCarrierListModal';
import extractCarrierById from './extractCarrierById';
import extractSZLTById from './extractSZLTById';
import extractVehiciesById from './extractVehiciesById';
import checkImportStatus from '../../Application/sagas/checkImportStatus';

export default function* watchDashboard() {
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_SZLT_LIST, loadRelationCarrierSzltList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_RELATION_CARRIER_VEHICLE_LIST, loadRelationCarrierVehicleList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_RELATION_VEHICLE_SZLT_LIST, loadRelationVehicleSzltList);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST_MODAL, loadCarrierListModal);

  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_SZLT_LIST, loadSZLTList);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_SZLT_BY_ID, loadSZLTById);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_CARRIER_LIST, loadCarrierList);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_CARRIER_BY_ID, loadCarrierById);
  yield takeLatest(REGION_REGISTRY_MODULE + LOAD_VEHICLES_LIST, loadVehiclesList);
  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_VEHICLES_BY_ID, loadVehiclesById);

  yield takeEvery(REGION_REGISTRY_MODULE + VEHICLES_HELPER, vehiclesHelper); // специально не LATEST. Несколько хелперов на странице
  yield takeEvery(REGION_REGISTRY_MODULE + CARRIER_HELPER, carrierHelper); // специально не LATEST. Несколько хелперов на странице
  yield takeEvery(REGION_REGISTRY_MODULE + SZLT_HELPER, szltHelper); // специально не LATEST. Несколько хелперов на странице

  yield takeEvery(REGION_REGISTRY_MODULE + SEND_VEHICLES_FGIS_TAXI, sendVehiclesFgisTaxi);

  yield takeEvery(REGION_REGISTRY_MODULE + CARRIER_FIELDS_VALIDATION, loadCarrierFieldsValidation);
  yield takeEvery(REGION_REGISTRY_MODULE + SZLT_FIELDS_VALIDATION, loadSZLTFieldsValidation);
  yield takeEvery(REGION_REGISTRY_MODULE + VEHICLE_FIELDS_VALIDATION, loadVehicleFieldsValidation);

  yield takeEvery(REGION_REGISTRY_MODULE + EXTRACT_SZLT, extractSZLTById);
  yield takeEvery(REGION_REGISTRY_MODULE + EXTRACT_VEHICLES, extractVehiciesById);
  yield takeEvery(REGION_REGISTRY_MODULE + EXTRACT_CARRIER, extractCarrierById);

  yield takeEvery(REGION_REGISTRY_MODULE + LOAD_STATUS_IMPORT, checkImportStatus);
}
